const tabBlocks = document.querySelectorAll('.block-tab-cycle');

const activateTab = (tabBlock, tabIndex) => {
	if (!tabBlock || tabIndex === null) return;

	const allTabs = tabBlock.querySelectorAll('.block-tab-cycle-tab');

	// Ensure index is within bounds
	tabIndex = parseInt(tabIndex);

	// Remove active class from all tabs
	allTabs.forEach((tab) => {
		tab.classList.remove('active');
	});

	// Remove active class from all navigation buttons
	const navButtons = tabBlock.querySelectorAll(
		'.block-tab-cycle__navigation .wp-block-button'
	);
	navButtons.forEach((button) => {
		button.classList.remove('active');
	});

	// Remove active class from ALL pagination dots in ALL pagination containers
	const paginationDots = tabBlock.querySelectorAll(
		'.swiper-pagination-bullet'
	);
	paginationDots.forEach((dot) => {
		dot.classList.remove('swiper-pagination-bullet-active');
	});

	// Add active class to current tab
	const currentTab = tabBlock.querySelector(
		`.block-tab-cycle-tab[data-index="${tabIndex}"]`
	);
	if (currentTab) {
		currentTab.classList.add('active');
	}

	// Add active class to navigation button
	const currentNavButton = tabBlock.querySelector(
		`.block-tab-cycle__navigation .wp-block-button .wp-block-button__link[data-tab-index="${tabIndex}"]`
	);
	if (currentNavButton) {
		currentNavButton.closest('.wp-block-button').classList.add('active');
	}

	// Add active class to ALL pagination dots with the current tab index (in each pagination container)
	const currentDots = tabBlock.querySelectorAll(
		`.swiper-pagination-bullet[data-tab-index="${tabIndex}"]`
	);
	currentDots.forEach((dot) => {
		dot.classList.add('swiper-pagination-bullet-active');
	});

	// Update mobile select
	const selectElement = tabBlock.querySelector(
		'.block-tab-cycle__mobile-select'
	);
	if (selectElement) {
		selectElement.value = tabIndex;
	}
};

const toggleTab = (e) => {
	e.preventDefault();
	const tabBlock = e.currentTarget.closest('.block-tab-cycle');
	const tabIndex = e.currentTarget.getAttribute('data-tab-index');

	activateTab(tabBlock, tabIndex);
};

const mobileSelect = (e) => {
	const tabBlock = e.currentTarget.closest('.block-tab-cycle');
	if (tabBlock) {
		activateTab(tabBlock, e.currentTarget.value);
	}
};

const navigateTab = (tabBlock, direction) => {
	const allTabs = tabBlock.querySelectorAll('.block-tab-cycle-tab');
	const activeTab = tabBlock.querySelector('.block-tab-cycle-tab.active');
	const totalTabs = allTabs.length;

	if (!activeTab || totalTabs === 0) return;

	const currentIndex = parseInt(activeTab.getAttribute('data-index'));
	let newIndex;

	if (direction === 'next') {
		newIndex = (currentIndex + 1) % totalTabs; // Wrap to 0 at end
	} else {
		newIndex = currentIndex === 0 ? totalTabs - 1 : currentIndex - 1; // Wrap to end at beginning
	}

	activateTab(tabBlock, newIndex);
};

if (tabBlocks.length) {
	tabBlocks.forEach((tabBlock) => {
		const tabs = tabBlock.querySelectorAll('.block-tab-cycle-tab');
		const navigationContainer = tabBlock.querySelector(
			'.block-tab-cycle__navigation'
		);

		if (tabs.length && navigationContainer) {
			const selectElement = tabBlock.querySelector(
				'.block-tab-cycle__mobile-select'
			);

			tabs.forEach((tab, index) => {
				// Find the button inside the tab
				const sourceButton = tab.querySelector(
					'.block-tab-cycle-tab__content .wp-block-button'
				);

				if (sourceButton) {
					// Clone the button for navigation
					const navButtonWrapper = sourceButton.cloneNode(true);
					const navButton = navButtonWrapper.querySelector(
						'.wp-block-button__link'
					);

					// Add data attribute and event listener to the cloned button
					navButton.setAttribute('data-tab-index', index);
					navButton.addEventListener('click', toggleTab);

					// Add the button to navigation
					navigationContainer.appendChild(navButtonWrapper);

					// Set data-index on the tab
					tab.setAttribute('data-index', index);

					// Hide the original button in the tab
					sourceButton.style.display = 'none';

					// Create option for mobile select
					if (selectElement) {
						const option = document.createElement('option');
						option.value = index;
						option.text = sourceButton.textContent.trim();
						selectElement.appendChild(option);
					}

					// Create pagination dots for ALL tabs (not just each tab)
					const paginationContainers = tabBlock.querySelectorAll(
						'.block-tab-cycle-tab__pagination'
					);
					paginationContainers.forEach((paginationContainer) => {
						// Clear existing dots first
						if (index === 0) {
							paginationContainer.innerHTML = '';
						}
						// Create dot for this tab
						const dot = document.createElement('button');
						dot.className = 'swiper-pagination-bullet';
						dot.setAttribute('data-tab-index', index);
						dot.setAttribute(
							'aria-label',
							`Go to slide ${index + 1}`
						);
						dot.addEventListener('click', toggleTab);
						paginationContainer.appendChild(dot);
					});

					// Add navigation arrow event listeners to this tab's controls
					const prevButton = tab.querySelector('.swiper-button-prev');
					const nextButton = tab.querySelector('.swiper-button-next');

					if (prevButton) {
						prevButton.addEventListener('click', (e) => {
							e.preventDefault();
							navigateTab(tabBlock, 'prev');
						});
					}

					if (nextButton) {
						nextButton.addEventListener('click', (e) => {
							e.preventDefault();
							navigateTab(tabBlock, 'next');
						});
					}

					// Set first tab and button as active
					if (0 === index) {
						tab.classList.add('active');
						navButtonWrapper.classList.add('active');
						navButtonWrapper.classList.add('initialized');

						// Set first pagination dot as active
						const firstDots = tabBlock.querySelectorAll(
							'.swiper-pagination-bullet[data-tab-index="0"]'
						);
						firstDots.forEach((dot) => {
							dot.classList.add(
								'swiper-pagination-bullet-active'
							);
						});
					}
				}
			});

			// Add mobile select event listener
			if (selectElement) {
				selectElement.addEventListener('change', mobileSelect);
			}
		}
	});
}
